import enums from '../enums.js';

const componentNames = ['box', 'boxLowContrast', 'boxHighContrast', 'boxLowContrastOverlay', 'boxHighContrastOverlay'];
const config = {
  styleProperties: [
    enums.properties.BACKGROUND_COLOR,
    enums.properties.FOREGROUND_COLOR,
    enums.properties.BORDER_COLOR,
    enums.properties.OUTLINE_COLOR,
    enums.properties.BORDER_RADIUS,
    enums.properties.BORDER_WIDTH,
    enums.properties.DENSITY
  ]
};

export default componentNames.reduce((obj, name) => Object.assign(obj, { [name]: config }), {});
